import type { ListDropdownButtonDefinition } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { Plugin } from '@ckeditor/ckeditor5-core';
import {
  addListToDropdown,
  createDropdown,
  Model,
} from '@ckeditor/ckeditor5-ui';
import { Collection, Locale } from '@ckeditor/ckeditor5-utils';

export default class VariablesPlugin extends Plugin {
  private readonly collection = new Collection<ListDropdownButtonDefinition & { id: string }>([], {
    idProperty: 'id',
  });

  private readonly dropdown = createDropdown(new Locale());

  init(): void {
    const { editor } = this;

    // The button must be registered among the UI components of the editor
    // to be displayed in the toolbar.
    editor.ui.componentFactory.add('variables', () => {
      this.dropdown.class = 'variables-btn';
      this.dropdown.buttonView.set({
        label: 'Variables',
        withText: true,
      });
      addListToDropdown(this.dropdown, this.collection);

      this.dropdown.on('execute', (event) => {
        editor.model.change((writer) => {
          // Insert the text at the user's current position.
          const textToInsert = `{${(event.source as { label: string }).label}}`;
          editor.model.insertContent(writer.createText(textToInsert));
          editor.editing.view.focus();
        });
      });

      return this.dropdown;
    });
  }

  addToCollection(label: string): void {
    if (!this.collection.get(label)) {
      this.collection.add({
        type: 'button',
        id: label,
        model: new Model({
          label,
          withText: true,
        }),
      });
    } else {
      console.warn(`[CKEditor VariablesPlugin] duplicated variable ${label}`);
    }
  }

  removeFromCollection(label: string): void {
    const item = this.collection.get(label);
    if (item) {
      this.collection.remove(item);
    }
  }

  setCollectionVisibility(value: boolean): void {
    this.dropdown.isEnabled = value;
  }

  static readonly pluginName = 'VariablesPlugin';
}
